"use client";
import { AppTextField } from "@/common";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, DatePickerProps } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import "dayjs/locale/vi";
import updateLocale from "dayjs/plugin/updateLocale";
import { forwardRef, memo } from "react";

dayjs.extend(updateLocale);

const customMonthNames = [
  "Tháng 1",
  "Tháng 2",
  "Tháng 3",
  "Tháng 4",
  "Tháng 5",
  "Tháng 6",
  "Tháng 7",
  "Tháng 8",
  "Tháng 9",
  "Tháng 10",
  "Tháng 11",
  "Tháng 12",
];

dayjs.updateLocale("vi", {
  months: customMonthNames,
});

const dayOfWeekVn = {
  0: "CN", // Chủ nhật
  1: "T2", // Thứ Hai
  2: "T3", // Thứ Ba
  3: "T4", // Thứ Tư
  4: "T5", // Thứ Năm
  5: "T6", // Thứ Sáu
  6: "T7", // Thứ Bảy
} as const;

const AppDatePicker = forwardRef<
  HTMLInputElement,
  DatePickerProps<dayjs.Dayjs> & {
    size?: "medium" | "small";
  }
>(
  (
    {
      sx,
      size = "medium",
      ...props
    }: DatePickerProps<dayjs.Dayjs> & {
      size?: "medium" | "small";
    },
    ref,
  ) => {
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
        <DatePicker
          inputRef={ref}
          dayOfWeekFormatter={(day) => dayOfWeekVn[day.day() as keyof typeof dayOfWeekVn]}
          slots={{
            textField: AppTextField,
          }}
          sx={{
            "& .MuiPickersCalendarHeader-label": {
              "&::first-letter": {
                textTransform: "uppercase !important",
              },
            },
            ...sx,
          }}
          {...props}
          slotProps={{
            ...props.slotProps,
            textField: {
              fullWidth: true,
              className: "",
              size,
              ...props.slotProps?.textField,
            },
          }}
        />
      </LocalizationProvider>
    );
  },
);
AppDatePicker.displayName = "AppDatePicker";

export default memo(AppDatePicker);
